import React from "react";

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">

          <div className="col-lg-3">
          <div className="branch-card">
                 <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Contact Us </h5>
                 <ul className="footer-links">
                 <li>
                    <a href="https://www.instagram.com/beris.design.atelier/"> @beris.design.atelier</a>
                    </li>
                    <li>
                    <a href="tel:+919527638317">+91-9527638317</a>  
                    </li>
                    </ul>               
            </div>
            </div>

            <div className="col-lg-3">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> BDA Presence </h5>
                <ul className="footer-links">
                  <li>
                    <a>
                      Jabalpur, Madhya pradesh <br /> INDIA
                      482002
                    </a>
                  </li>
                  <li>
                    <a >
                      Pune, Maharashtra <br /> INDIA
                      411045
                    </a>
                  </li>
                  <li>
                    <a >
                    New Delhi, New Delhi<br /> INDIA
                      110001
                    </a>
                  </li>
                </ul>
              </div>
            </div>
 
            <div className="col-lg-3">
            <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Help </h5>
                <ul className="footer-links">
                  <li>
                    <a href="/Termconditions"> Terms & Conditions </a>
                  </li>
                  <li>
                    <a href="/Privacy"> Privacy Policy </a>
                  </li>
                </ul>
              </div>
              </div>

              <div className="col-lg-3">
              <div className="info-side">
              <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Social media </h5>
                <div className="foot-social mt-20">
                  <a href="https://www.instagram.com/beris.design.atelier/">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/mudit-beri-01107422/">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="foot">
          <div className="row">
            <div className="col-lg-5">
              <p className="fsz-13">
                © 2024 DOAGuru InfoSystems.<a  href="/login"> All Right Reserved </a>
              </p>
            </div>
            <div className="col-lg-7">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="/"> Home </a>
                <a href="/innerpages/about"> About </a>
                <a href="/innerpages/services"> Services </a>
                <a href="#"> Portfolio
                {/* /innerpages/portfolio */}
                 </a>
                {/* <a href="/innerpages/blog">Blog</a> */}
                <a href="/innerpages/contact"> contact </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
